import { useCallback, useState } from 'react'

/**
 * A table's first column stays put while the rest scrolls sideways, so a row keeps its name on a phone (the usual pinned
 * column of data tables: SAP Fiori, Material). The cell paints its own background: the others slide under it.
 */
export const PIN = 'sticky left-0 z-[1] bg-surface'

/**
 * The pinned column's right edge, drawn once something has slid under it. A box-shadow, not a border: collapsed table
 * borders are painted by the table and do not travel with a sticky cell.
 */
export const PIN_EDGE = 'shadow-[inset_-1px_0_0_var(--color-line)]'

/** whether a sideways scroller has left its left edge; wire `onScroll` to the wrapper, `edge` to the pinned cells */
export function useScrolledSideways() {
  const [scrolled, setScrolled] = useState(false)
  const onScroll = useCallback((e: React.UIEvent<HTMLElement>) => setScrolled(e.currentTarget.scrollLeft > 0), [])
  return { onScroll, edge: scrolled ? PIN_EDGE : '' }
}
